function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#expert-portfolio-info-pie_svg__clip0_2330_4773)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.704 192.031c-.966 1.986-3.364 2.82-5.312 1.778a102.992 102.992 0 01-49.58-59.692 103 103 0 016.148-77.353c.992-1.974 3.433-2.673 5.367-1.605l5.62 3.102c1.935 1.068 2.628 3.497 1.65 5.478A88.581 88.581 0 0060.703 180.83c1.941 1.055 2.773 3.44 1.807 5.427l-2.807 5.774z",
  fill: "#2AA4AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.726 181.955c1.332 1.762.989 4.277-.824 5.541a103.004 103.004 0 01-98.304 10.669c-2.042-.845-2.917-3.228-1.993-5.235l2.684-5.832c.924-2.006 3.296-2.875 5.343-2.043a88.581 88.581 0 0083.564-9.07c1.82-1.252 4.324-.912 5.657.85l3.873 5.12z",
  fill: "#1B8388"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103 4c0-2.21 1.792-4.008 3.999-3.922a103.003 103.003 0 0193.331 69.22 102.994 102.994 0 011.504 62.698 102.994 102.994 0 01-32.044 49.414c-1.682 1.433-4.203 1.127-5.569-.609l-3.97-5.045c-1.366-1.737-1.059-4.245.613-5.688a88.582 88.582 0 0025.84-96.052 88.581 88.581 0 00-79.705-59.506c-2.207-.1-3.999-1.88-3.999-4.09V4z",
  fill: "#3DC5CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.42 53.231c-1.91-1.11-2.565-3.564-1.381-5.429A103 103 0 0196.504.205c2.205-.14 4.04 1.616 4.094 3.824l.156 6.418c.053 2.209-1.695 4.033-3.899 4.186a88.58 88.58 0 00-68.34 40.425c-1.196 1.858-3.636 2.511-5.546 1.4l-5.55-3.227z",
  fill: "#93DFE3"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "expert-portfolio-info-pie_svg__clip0_2330_4773"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h206v206H0z"
})));

function SvgExpertPortfolioInfoPie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 206,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgExpertPortfolioInfoPie;